export default "__VITE_ASSET__1cd47db9__"